import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import FlatButton from "../../commons/FlatButton";

const Wrapper = styled.div`
  h2 {
    text-transform: uppercase;
    font-family: Lato;
    font-size: 24px;
  }
`;

const CheckoutResult = ({ orderID, isAnonymous, reloadAuthenticatedUser }) => {
  useEffect(() => {
    if(orderID) reloadAuthenticatedUser();
  }, []);

  return (
    <Wrapper>
      <div class="row my-5">
        <div className="col-12 col-lg-6 mx-auto text-center">
          {orderID !== null && (
            <div>
              <h4>Your order has been placed successfully!</h4>
              <h2>Order ID: {orderID}</h2>
              {
                isAnonymous?
                  <h4>To know more about your order, create an <Link to="/signup">account</Link> with the same email you used for this order.</h4>
                  :
                  <h4>Click <Link to={`/myaccount/?order-id=${orderID}`}>here</Link> to view your purchase</h4>
              }
            </div>
          )}

          {orderID === null && (
            <div>
              <div>Oops! Something went wrong with your order!</div>
              <p>We apologize for the inconvenience.</p>
              <p>
                Please <Link to="/contact">get in touch</Link> and we'll assist
                you
              </p>
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default CheckoutResult;
